// The home page uses Flickity, the rest use Swiper:

import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

export const setupSwiper = () => {
  const sliderContainers = document.querySelectorAll('.region--content .swiper-container')

  for (const element of sliderContainers) {
    setupSwiperInstance(element)
  }
}

function setupSwiperInstance (element) {
  const slides = element.querySelectorAll('.swiper-slide')
  if (slides.length > 1) {
    createSwiperForOne(element)
  } else {
    createSwiperForMany(element)
  }
}

function createSwiperForOne (element) {
  console.log('Swiper for One')
  return new Swiper(element, {
    loop: true,
    speed: 400,
    spaceBetween: 16,
    autoHeight: true,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    watchOverflow: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    }
  })
}

function createSwiperForMany (element) {
  console.log('Swiper for Many')
  return new Swiper(element, {
    loop: false,
    speed: 400,
    spaceBetween: 16,
    autoHeight: true,
    centeredSlides: true,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    autoplay: false
  })
}
